import { Link } from 'react-router-dom';

const milestones = [
  { year: '2019', title: '平台起步', desc: '网址大全正式上线，从最初的 200 个站点开始整理优质入口。' },
  { year: '2021', title: '分类体系升级', desc: '建立多领域多级分类与标签体系，收录站点突破 5000 个。' },
  { year: '2023', title: '检索体验优化', desc: '上线多维筛选、排序与关联推荐，大幅提升找站效率。' },
  { year: '2026', title: '权威化与开放', desc: '引入来源核验机制与收录申请通道，坚持中立、真实、可用。' },
];

const team = [
  { name: '林知远', role: '平台负责人', desc: '十年互联网产品经验，负责目录方向与内容标准制定。', icon: 'ri-user-star-line' },
  { name: '苏晚晴', role: '内容主编', desc: '资深媒体编辑，主导站点审核、分类规划与内容质量把关。', icon: 'ri-edit-2-line' },
  { name: '陈屿', role: '技术负责人', desc: '负责检索、筛选与数据体系搭建，保障浏览体验稳定流畅。', icon: 'ri-code-s-slash-line' },
  { name: '周棉', role: '用户运营', desc: '对接收录申请与用户反馈，持续优化平台内容与体验。', icon: 'ri-customer-service-2-line' },
];

const values = [
  { icon: 'ri-shield-check-line', title: '专业中立', desc: '以可核验的事实与公开来源为依据，不做竞价排序。' },
  { icon: 'ri-eye-line', title: '真实可用', desc: '定期巡检失效链接，确保每一栏目都能真正帮到用户。' },
  { icon: 'ri-heart-3-line', title: '体验优先', desc: '从信息层级到检索路径，始终围绕“更快找到”打磨。' },
];

export default function AboutPage() {
  return (
    <div className="w-full animate-fade-in">
      <section className="w-full border-b border-background-200 bg-secondary-50">
        <div className="mx-auto max-w-[1080px] px-4 py-12 md:px-8 md:py-16">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-compass-3-line"></i>
            关于网址大全
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
            做值得信赖的综合网站目录
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-foreground-600 md:text-base">
            网址大全的使命，是让找网站这件事变得简单而可靠。我们面向普通网民、企业用户与行业从业者，
            把散落在互联网各处的优质站点整理成结构清晰、可检索、可筛选的目录，帮助用户在最短时间内找到真正需要的入口。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-[1080px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {values.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h2 className="mt-4 text-base font-semibold text-foreground-900">{item.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <i className="ri-history-line text-accent-500"></i>
            发展历程
          </h2>
          <ol className="mt-6 border-l-2 border-background-200 pl-6">
            {milestones.map((item) => (
              <li key={item.year} className="relative pb-8 last:pb-0">
                <span className="absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50"></span>
                <span className="font-heading text-sm font-bold text-accent-600">{item.year}</span>
                <h3 className="mt-1 text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-14">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <i className="ri-team-line text-primary-500"></i>
            团队介绍
          </h2>
          <p className="mt-2 text-sm text-foreground-500">一群相信“好好整理信息”本身就很有价值的人。</p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {team.map((member) => (
              <div key={member.name} className="rounded-lg border border-background-200 bg-background-50 p-5 text-center">
                <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className={`${member.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-900">{member.name}</h3>
                <p className="text-xs text-primary-600">{member.role}</p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{member.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-6 rounded-lg border border-background-200 bg-secondary-50 p-6 md:flex-row md:items-center md:p-8">
          <div>
            <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">想推荐一个优质网站？</h2>
            <p className="mt-2 text-sm text-foreground-600">
              欢迎通过联系我们提交收录申请或反馈建议，我们会尽快审核并回复。
            </p>
          </div>
          <div className="flex flex-shrink-0 flex-wrap gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              联系我们
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              浏览全部网站
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}